export default __webpack_public_path__ + "static/media/fireFN14.f6e2474a.svg";